import React from 'react';

export const DifferenceTab = () => {
    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-3">Workflow vs Task: Understanding the Difference</h3>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                <div className="space-y-4">
                    <h4 className="text-lg font-medium text-blue-600">📋 Tasks</h4>
                </div>
                <div className="space-y-4">
                    <h4 className="text-lg font-medium text-green-600">🔄 Workflows</h4>
                </div>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                <div className="space-y-4">
                    <div className="bg-blue-50 rounded-lg p-4 h-full">
                        <h5 className="font-medium text-blue-900 mb-2">What is a Task?</h5>
                        <p className="text-blue-800 text-sm mb-3">
                            A task is a single, specific action that needs to be completed. It's the smallest unit of work in the system.
                        </p>
                        <h5 className="font-medium text-blue-900 mb-2">Examples:</h5>
                        <ul className="text-blue-800 text-sm space-y-1">
                            <li>• File GSTR-1 for ABC Industries</li>
                            <li>• Reconcile bank statement for December</li>
                            <li>• Prepare TDS challan for Q3</li>
                            <li>• Review purchase invoices</li>
                        </ul>
                        <h5 className="font-medium text-blue-900 mb-2 mt-3">Characteristics:</h5>
                        <ul className="text-blue-800 text-sm space-y-1">
                            <li>• Has a single assignee</li>
                            <li>• Specific due date</li>
                            <li>• Clear deliverable</li>
                            <li>• Can be standalone or part of workflow</li>
                        </ul>
                    </div>
                </div>

                <div className="space-y-4">
                    <div className="bg-green-50 rounded-lg p-4 h-full">
                        <h5 className="font-medium text-green-900 mb-2">What is a Workflow?</h5>
                        <p className="text-green-800 text-sm mb-3">
                            A workflow is a series of connected tasks that together complete a larger business process. It defines the sequence and dependencies between tasks.
                        </p>
                        <h5 className="font-medium text-green-900 mb-2">Examples:</h5>
                        <ul className="text-green-800 text-sm space-y-1">
                            <li>• Monthly GST Compliance (8 tasks)</li>
                            <li>• New Client Onboarding (12 tasks)</li>
                            <li>• Annual Audit Preparation (15 tasks)</li>
                            <li>• Quarterly TDS Filing (6 tasks)</li>
                        </ul>
                        <h5 className="font-medium text-green-900 mb-2 mt-3">Characteristics:</h5>
                        <ul className="text-green-800 text-sm space-y-1">
                            <li>• Contains multiple related tasks</li>
                            <li>• Has task dependencies</li>
                            <li>• Multiple assignees possible</li>
                            <li>• Tracks overall progress</li>
                            <li>• Can be templated for reuse</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="mt-4 bg-gray-50 rounded-lg p-6">
                <h4 className="text-lg font-medium text-gray-900 mb-4">🔗 How They Work Together</h4>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div className="text-center">
                        <div className="bg-blue-100 rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-2">
                            <span className="text-blue-600 font-bold">1</span>
                        </div>
                        <h5 className="font-medium text-gray-900">Create Workflow</h5>
                        <p className="text-sm text-gray-600">Define the overall process and break it into tasks</p>
                    </div>
                    <div className="text-center">
                        <div className="bg-green-100 rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-2">
                            <span className="text-green-600 font-bold">2</span>
                        </div>
                        <h5 className="font-medium text-gray-900">Assign Tasks</h5>
                        <p className="text-sm text-gray-600">Each task gets assigned to team members with due dates</p>
                    </div>
                    <div className="text-center">
                        <div className="bg-purple-100 rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-2">
                            <span className="text-purple-600 font-bold">3</span>
                        </div>
                        <h5 className="font-medium text-gray-900">Track Progress</h5>
                        <p className="text-sm text-gray-600">Monitor individual tasks and overall workflow completion</p>
                    </div>
                </div>
            </div>
        </div>
    );
};